import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styled from "@emotion/styled";
import { injectIntl } from "react-intl";

import ColorCircle from "components/ColorCircle";
import DatePicker from "components/DatePicker";
import Switch from "components/Switch";

import ParkkiTheme from "themes/ParkkiTheme";

const PickersSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${ParkkiTheme.spacings.base};
`;

const DatePickersContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;

  & > * {
    margin: ${ParkkiTheme.spacings.tiny} ${ParkkiTheme.spacings.tiny};
  }
`;

const StyledDateLabel = styled.div`
  margin-left: 8px;
  width: 150px;
  color: ${(props) =>
    props.disabled ? ParkkiTheme.colors.disabledGrey : "default"};
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: 22px;
`;

const DatePickerContainer = styled.div`
  width: 175px;
`;

const StyledColorCircle = styled(ColorCircle)`
  margin-left: 38px;
`;

const ComparedLabel = styled.div`
  color: ${(props) =>
    props.disabled ? ParkkiTheme.colors.disabledGrey : "default"};
`;

const OrangeSwitch = styled(Switch)`
  .MuiSwitch-switchBase {
    color: ${(props) =>
      props.checked ? `${ParkkiTheme.colors.orange} !important` : "default"};
  }

  .MuiSwitch-track,
  .MuiSwitch-track.Mui-checked {
    background-color: ${(props) =>
      props.checked ? `${ParkkiTheme.colors.orange} !important` : "default"};
  }
`;

class DatePickersSectionComponent extends React.Component {
  shouldDisableDate = (date) => {
    return date.isAfter(moment().subtract(1, "days").endOf("day"), "day");
  };

  renderAnalysisPeriod = () => {
    const { startDate, endDate, intl } = this.props;

    return (
      <DatePickersContainer>
        <StyledColorCircle color={ParkkiTheme.colors.blue} />
        <StyledDateLabel>
          {intl.messages["customAnalysisScene.filters.analysisPeriod"]}
        </StyledDateLabel>

        <div>{startDate.label}</div>
        <DatePickerContainer>
          <DatePicker
            value={startDate.value}
            onChange={startDate.onChange}
            shouldDisableDate={this.shouldDisableDate}
          />
        </DatePickerContainer>

        <div>{endDate.label}</div>
        <DatePickerContainer>
          <DatePicker
            value={endDate.value}
            onChange={endDate.onChange}
            shouldDisableDate={this.shouldDisableDate}
          />
        </DatePickerContainer>
      </DatePickersContainer>
    );
  };

  renderComparedPeriod = () => {
    const {
      comparedStartDate,
      comparedEndDate,
      endDate,
      withComparison,
      intl,
    } = this.props;

    return (
      <>
        <DatePickersContainer>
          <SwitchContainer>
            <OrangeSwitch
              checked={withComparison.value}
              onChange={withComparison.onChange}
            />
            <StyledDateLabel disabled={!withComparison.value}>
              {intl.messages["customAnalysisScene.filters.comparedToPeriod"]}
            </StyledDateLabel>
          </SwitchContainer>

          <ComparedLabel disabled={!withComparison.value}>
            {comparedStartDate.label}
          </ComparedLabel>
          <DatePicker
            style={{ minWidth: "175px", maxWidth: "175px" }}
            autoOk
            value={comparedStartDate.value}
            onChange={comparedStartDate.onChange}
            shouldDisableDate={this.shouldDisableDate}
            disabled={!withComparison.value}
          />

          <ComparedLabel disabled={!withComparison.value}>
            {endDate.label}
          </ComparedLabel>
          <DatePicker
            style={{ minWidth: "175px", maxWidth: "175px" }}
            disabled
            value={comparedEndDate.value}
          />
        </DatePickersContainer>
      </>
    );
  };

  render() {
    return (
      <PickersSection>
        {this.renderAnalysisPeriod()}
        {this.renderComparedPeriod()}
      </PickersSection>
    );
  }
}

DatePickersSectionComponent.defaultProps = {};

DatePickersSectionComponent.propTypes = {
  endDate: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  startDate: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
};

const DatePickersSection = injectIntl(DatePickersSectionComponent);
export { DatePickersSection };
